<div class="modal" tabindex="-1" role="dialog" style="display: block;">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-primary" style="width: 93%; height: 100%;">
                    <i class="fa-solid fa-screencast icon-header"></i>
                    {{screenshareHeaderLabel}}
                </h4>
                <!-- <button type="button" class="btn hover-coursor" (click)="closePopup()">
                    <i class="fal fa-times p-2" aria-hidden="true" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{closeLabel}}">
                    </i>
                </button> -->
            </div>
            <div class="modal-body mx-2 px-3 custom-area contant-box-h">
                <div
                    style="width:100%;height:500px;overflow-y: auto;margin-top: 10px;display:flex; flex-wrap: wrap; justify-content: space-around; ">
                    <ng-container *ngFor="let info of screenDetails; index as i">
                        <div class="screen-selection-container" (click)="selectScreen(i)" [ngClass]="{
        'selected-screen': selectedScreenIds.has(i) === true,
        'disabled-screen': selectedScreenIds.has(i) === false && selectedScreenIds.size >= maxSelectableScreens
     }">
                            <div class="screen-selection-checkmark" *ngIf="selectedScreenIds.has(i)">
                                <i class="fa fa-check"></i>
                            </div>
                            <div class="screen-selection-img">
                                <img [src]="screenDetails[i].base64Image" alt="Screen {{i+1}}">
                            </div>
                            <div class="screen-selection-label">
                                <span>Screen {{screenDetails[i].id + 1}}</span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="modal-footer py-2">
                <div class="w-100">
                </div>
                <div>
                    <div>
                        <button type="button" class="btn button-primary mx-1 hover-coursor" (click)="startCall()"
                            *ngIf="selectedScreenIds.size > 0">
                            Select
                        </button>
                        <button type="button" class="btn button-danger mx-1 hover-coursor" (click)="closePopup()">
                            {{closeLabel}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>